export const translations = [
    'add',
    'contactLabel',
    'addToBagButtonLabel',
    'checkoutLabel',
    'discount',
    'discounts',
    'discountDisclaimerLabel',
    'donationTo',
    'goShoppingLabel',
    'orderSummaryTitle',
    'item',
    'itemDiscountPercentageLabel',
    'learnMore',
    'loading',
    'furtherInfoLabel',
    'makeADonation',
    'noItemsInCollection',
    'noResultsMessage',
    'outOfStock',
    'productSampleLabel',
    'quantityLabel',
    'recommendedProductsTitle',
    'selectLabel',
    'remove',
    'freeLabel',
    'removeLabel',
    'replenishmentCancelErrorText',
    'replenishmentDisclaimerAgreeButton',
    'replenishmentDisclaimerCancelButton',
    'replenishmentDisclaimerInfoText',
    'replenishmentDisclaimerText',
    'replenishmentDisclaimerTitle',
    'replenishmentFailedText',
    'replenishmentSuccessText',
    'retryLabel',
    'samplesAndOffersLabel',
    'saveForLater',
    'sizeLabel',
    'subtotal',
    'shoppingBagTitle',
    'cartEmpty',
    'editLabel',
    'cartEmptyTitleLabel',
    'addedToCartLabel',
    'cartPageTitle',
    'actionButtonLabel',
    'editButtonLabel',
    'offerCodeLabel',
    'applyLabel',
    'addingLabel',
    'applyOfferLabel',
    'congratulationsCartTabOfferLabel',
    'congratulationsOffersLabel',
    'failedToApplyOffer',
    'loadingLabel',
    'notQualifiedOffersLabel',
    'offerApplied',
    'qualifiedOffersLabel',
    'productsTitle',
    'shippingLabel',
    'estimatedVatIncludedLabel',
    'shopBestsellersButtonText',
    'homepageButtonText',
    'totalEstimate',
    'chooseSamplesMessage',
    'samplesInfoMessage',
    'emptyCartSignInMessage',
    'cartItemsCountLimit',
    'klarna',
    'klarnaPaymentsOf',
    'klarnaAvailableForOrders',
    'close',
    'afterpayNotEligibleMessage',
    'giftWrap',
    'engravingLabel',
    'engravingInfo',
    'engravingDisclaimer',
    'engravingNote',
    'donationLabel',
    'standardShippingLabel',
    'namedDayShippingLabel',
    'secondDayShippingLabel',
    'overnightShippingLabel',
    'colissimoShippingLabel',
    'electronicShippingLabel',
    'saturdayShippingLabel',
    'clickAndCollectShipping',
    'storeForClickAndCollect',
    'weAccept',
    'paymentTypes',
    'salesTaxLabel',
    'toBeDeterminedLabel',
    'taxesInfoLabel',
    'complimentaryLabel',
    'orderItemCountSingular',
    'orderItemCountPlural',
    'tbdLabel',
    'retailDeliveryFeeLabel',
    'retailDeliveryFeeTerms',
    'roadImprovementFeeLabel',
    'roadImprovementFeeTerms',
    'subscribeAndSaveDiscountPlusFreeShipping',
    'discountCannotCombinedOtherOffers',
    'subscribeAndSaveDiscount',
    'getProductOnScheduleCancelAnytime',
    'stepOneSchedule',
    'selectYourDeliveryScheduleAndAddProduct',
    'stepTwoCheckout',
    'checkoutToCompleteYourOrder',
    'stepThreeDelivery',
    'freeDeliveryPlusDiscount',
    'autoReplenishmentTermsAndConditions',
    'autoReplenishmentFrequentlyAskedQuestions',
    'autoReplenishmentTermsConditionsAndFaq',
    'agreeLabel',
    'cancelLabel',
    'replenishmentDisclaimer',
    'replenishmentDisclaimerConfirmation',
    'orderItemCountSingular',
    'orderItemCountPlural',
    'soldOutButtonLabel',
    'selectLoyaltyOffers',
    'estimatedPointTotalVary',
    'excludedFromDiscounts',
    'itemIsTempOutOfStock',
    'shippingRestrictionHazmat',
    'sameDayDeliveryLabel',
    'clickCollectTitle',
    'itemLimitedToPerCustomer',
    'maximumNumberOfItemsInBag',

    // elc_product
    'decreaseProductQuantity',
    'increaseProductQuantity',

    // elc_offers
    'samplesLabel',
    'offersLabel',
    'sorryNoOffersAvailable',
    'offer_invalid',
    'offer_expired',
    'best_discount_applied',
    'offer_inapplicable',
    'offer_removed',
    'offerDeferred',
    'offerSampleOutOfStock',
    'offerRemovedSkuUnavailable',
    'offerReplaced',
    'offerBenefitNotApplied',
    'offerDeepDiscount',

    // elc_loyalty
    'loyaltyName',
    'selectLoyaltyNameOffers',
    'earnLoyaltyPointsWithPurchase',
    'noOffersAvailableShopToEarnPoints',
    'perksLabel',
    'perkPerksLabel',
    'redeemLabel',
    'redeemRewards',
    'availableToRedeem',

    // elc_general
    'added',
    'itemsLabel',
    'pointsLabel',
    'pleaseCheckAgainLater'
];
